import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

export default function GenderIcon(props) {
  const { t } = useTranslation();

  if (props.gender == "Male") {
    return (
      <div className="relative group w-max cursor-pointer text-center">
        <Icon name="male" size="large" />
        <div class="z-10 absolute w-[120px] left-1/2 -translate-x-1/2 bg-gray-800 text-white text-sm px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition duration-300 pointer-events-none">
          {t(props.gender)}
        </div>
      </div>
    );
  }

  if (props.gender == "Female") {
    return (
      <div className="relative group w-max cursor-pointer text-center">
        <Icon name="female" size="large" />
        <div class="z-10 absolute w-[120px] left-1/2 -translate-x-1/2 bg-gray-800 text-white text-sm px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition duration-300 pointer-events-none">
          {t(props.gender)}
        </div>
      </div>
    );
  }

  return (
    <div className="relative group w-max cursor-pointer text-center">
      <Icon name="child" size="large" />
      <div class="z-10 absolute w-auto left-1/2 -translate-x-1/2 bg-gray-800 text-white text-sm px-3 py-1 rounded opacity-0 group-hover:opacity-100 transition duration-300 pointer-events-none">
        {t(props.gender)}
      </div>
    </div>
  );

}
